// @flow
import React from 'react';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { AlternativePriceTitle } from 'Components/widgets/alternative-proposals/alternative-price-title/AlternativePriceTitle';
import { Icon } from 'Components/frameworks/icon/Icon';

type Props = {|
  iconWidth?: string,
  proposal?: Proposal,
  title: string,
|};

export const AlternativeProposalHeader = ({ title, proposal, iconWidth = '6rem' }: Props) => {
  return (
    <div className="bg-white rounded-small md:flex md:justify-center md:w-full">
      <div className="AlternativeProposalsModal-header flex py-2 px-6 md:py-4 md:items-center md:w-full lg:mx-6 lg:px-0">
        {proposal ? (
          <AlternativePriceTitle proposal={proposal} title={title} />
        ) : (
          <div className="flex">
            <Icon
              className="alternative-price-title-icon alternative-price-title-icon--full"
              color={COLORS.BLUE}
              name={ICONS.LIGHTBULB}
              width={iconWidth}
              hasRtl
            />
            <span className="alternative-proposal-title font-brand ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6 text-blue">
              {title}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
